import styled, { keyframes } from 'styled-components';

const fadeInAnimation = keyframes` 
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }

`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 15px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
  .ant-table-wrapper {
    border: 1px solid #e8e8e8;
    margin-top: 15px;
    width: 425px;
    height: 220px;
    overflow: hidden;
    @media (max-width: 768px) {
      width: auto;
    }
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
      margin-left: 0;
  }
  .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-table-thead > tr > th .ant-table-header-column {
    font-size: 14px;
    font-weight: 600;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    font-size: 14px;
    p {
      font-size: 14px;
    }
  }
  .ant-checkbox + span {
    font-size: 14px;
  }
  .ant-table-thead > tr > th .ant-table-filter-selected.anticon {
    color: #000 !important;
  }
  .ant-empty {
    margin-top: 30px !important;
  }
  .ant-table-placeholder {
    border-bottom: 1px solid transparent;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #000;
    border-color: #000;
  }
  .ant-checkbox-checked::after {
    border: 1px solid #000;
    border-radius: 2px;
  }
  .visible {
    animation: ${fadeInAnimation} ease 0.8s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
  .hidden {
    opacity: 1;
  }
  .ant-table-body {
    max-height: 160px !important;
  }
`;
export const SearchContainer = styled.div`
  .ant-btn {
    line-height: 0;
  }
  .ant-btn-primary,
  .ant-btn,
  .ant-btn:active,
  .ant-btn:focus {
    color: #fff;
    background-color: ${props => (props.mailRoom ? '#50BE77' : '#000')};
    border-color: ${props => (props.mailRoom ? '#50BE77' : '#000')};
    font-family: ${props => props.mailRoom && 'Montserrat !important'};
    text-transform: ${props => props.mailRoom && 'uppercase !important'};
    font-size: 12px;
    height: 30px;
    border-radius: ${props => (props.mailRoom ? '8px' : '50px')};
    font-weight: ${props => props.mailRoom && 600};
  }
  .searchInput {
    margin-bottom: 15px !important;
    font-family: ${props => props.mailRoom && 'Montserrat !important'};
    border-color: ${props => props.mailRoom && '#D2EA8C'};
  }
  .searchInput:hover, .searchInput:focus {
    border-color: #D2EA8C;
    outline-color: #D2EA8C;
  }
`;
